module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/isBoolean.js
// module id = 81
// module chunks = 0